module.exports = __webpack_public_path__ + "static/media/thepetapp.99051871.png";